// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Report_attributes_SalvarOpcaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /so/report_attributes/salvar_opcao
 *
 * Creates or updates an option for a select-type report attribute.
 * - Create: requires attribute_id, value, and display_order (id is null)
 * - Update: requires id, value, and display_order
 */
import { registerContract } from './validate'

export interface Report_attributes_SalvarOpcaoInput {
so_rao_value: string
so_rao_display_order: number
so_rao_id?: number
so_rao_attribute_id?: number
}

registerContract('Report_attributes_SalvarOpcaoInput', {
  so_rao_value:         { type: 'string',  required: true },
  so_rao_display_order: { type: 'number',  required: true },
  so_rao_id:            { type: 'number',  required: false },
  so_rao_attribute_id:  { type: 'number',  required: false },
})
